import {TimetrackingCtl} from '@extensions/sticker/controllers/timetracking-ctl'
import {TimetrackerValue} from 'yougile-model'

export const getStickerTitle = (stickerValue: TimetrackerValue) => {
  const {h2s} = TimetrackingCtl

  return h2s(stickerValue.plan, '—')
}
